export default {
  TableHead: [
    [
      {
        displayName: 'payout.datatable.number',
      },
      {
        displayName: 'payout.datatable.ticketid',
      },
      {
        displayName: 'payout.datatable.requestresponse',
      },
      {
        displayName: 'payout.datatable.retry',
      },
    ],
  ],
};
